
export default {
  name: 'CameraTest',
  data () {
    return {
      diag: { protocol: '', secure: false, hasMD: false, hasGUM: false, ua: '', platform: '' },
      permResult: null,
      gumResult: '',
      gumOk: false,
      testing: false,
      videoStream: null
    }
  },
  mounted () {
    this.diag.protocol = window.location.protocol
    this.diag.secure = window.isSecureContext
    this.diag.hasMD = !!navigator.mediaDevices
    this.diag.hasGUM = !!(navigator.mediaDevices && navigator.mediaDevices.getUserMedia)
    this.diag.ua = navigator.userAgent.includes('Safari') && !navigator.userAgent.includes('Chrome') ? 'Safari'
      : navigator.userAgent.includes('MicroMessenger') ? '微信内置浏览器'
      : navigator.userAgent.includes('Chrome') ? 'Chrome' : '其他'
    this.diag.platform = navigator.platform || '未知'
    this.queryPermission()
  },
  beforeDestroy () { this.stopCamera() },
  methods: {
    async queryPermission () {
      try {
        if (navigator.permissions && navigator.permissions.query) {
          const result = await navigator.permissions.query({ name: 'camera' })
          this.permResult = `state=${result.state}`
        } else {
          this.permResult = 'Permissions API 不支持（iOS Safari 可能不支持 camera 权限查询）'
        }
      } catch (e) {
        this.permResult = `Permissions API 异常: ${e.name}: ${e.message}`
      }
    },
    async testCamera () {
      this.testing = true; this.gumResult = ''
      try {
        const stream = await navigator.mediaDevices.getUserMedia({
          video: { facingMode: { ideal: 'environment' } }
        })
        this.videoStream = stream
        this.$nextTick(() => {
          if (this.$refs.video) this.$refs.video.srcObject = stream
        })
        this.gumResult = '✅ getUserMedia 成功! 摄像头可用'
        this.gumOk = true
      } catch (err) {
        const name = err.name || 'UnknownError'
        const map = {
          NotAllowedError: '摄像头权限被拒绝。请前往 Safari 设置 → 本网站 → 允许摄像头',
          NotFoundError: '未检测到摄像头设备',
          NotReadableError: '摄像头被其他应用占用',
          OverconstrainedError: '摄像头不支持所请求的参数 (facingMode: ideal environment)',
          SecurityError: '安全策略阻止摄像头访问。请确认使用 HTTPS'
        }
        this.gumResult = `❌ ${name}: ${err.message}\n\n${map[name] || '未知错误'}`
        this.gumOk = false
      } finally { this.testing = false }
    },
    stopCamera () {
      if (this.videoStream) {
        this.videoStream.getTracks().forEach(t => t.stop())
        this.videoStream = null
      }
    }
  }
}
